export const categories = [
  { id: 'all', name: '全部作品', slug: 'all' },
  { id: 'hot', name: '本周热门', slug: 'hot' },
  { id: 'new', name: '最新上架', slug: 'new' },
  { id: 'shounen', name: '热血少年', slug: 'shounen' },
  { id: 'romance', name: '恋爱甜宠', slug: 'romance' },
  { id: 'fantasy', name: '奇幻冒险', slug: 'fantasy' },
  { id: 'action', name: '动作格斗', slug: 'action' },
  { id: 'comedy', name: '搞笑日常', slug: 'comedy' },
  { id: 'suspense', name: '悬疑推理', slug: 'suspense' },
  { id: 'scifi', name: '科幻未来', slug: 'scifi' },
];